import React, { useState } from 'react';

const RazzCreationForm = () => {
  const [cardDetails, setCardDetails] = useState('');
  const [numberOfSpots, setNumberOfSpots] = useState(1);
  const [pricePerSpot, setPricePerSpot] = useState(0);
  const [selectedGroup, setSelectedGroup] = useState('');
  const [url, setUrl] = useState('');
  const [description, setDescription] = useState('');

  const handleCreateRazz = () => {
    // Implement logic to handle the creation of Razz with the form data
    console.log('Creating Razz with the following data:');
    console.log('Card Details:', cardDetails);
    console.log('Number of Spots:', numberOfSpots);
    console.log('Price Per Spot:', pricePerSpot);
    console.log('Selected Group:', selectedGroup);
    console.log('URL:', url);
    console.log('Description:', description);
  };

  return (
    <div>
      <h2>Create Razz</h2>
      <div>
        <label>
          Card Details:
          <input type="text" value={cardDetails} onChange={(e) => setCardDetails(e.target.value)} />
        </label>
      </div>
      <div>
        <label>
          Number of Spots:
          <input type="number" value={numberOfSpots} onChange={(e) => setNumberOfSpots(e.target.value)} />
        </label>
      </div>
      <div>
        <label>
          Price Per Spot:
          <input type="number" value={pricePerSpot} onChange={(e) => setPricePerSpot(e.target.value)} />
        </label>
      </div>
      <div>
        <label>
          Group Options:
          <select value={selectedGroup} onChange={(e) => setSelectedGroup(e.target.value)}>
            <option value="">Select Group</option>
            <option value="Group1">Group 1</option>
            <option value="Group2">Group 2</option>
            {/* Add more predefined group options */}
          </select>
        </label>
      </div>
      <div>
        <label>
          URL:
          <input type="text" value={url} onChange={(e) => setUrl(e.target.value)} />
        </label>
      </div>
      <div>
        <label>
          Description:
          <textarea value={description} onChange={(e) => setDescription(e.target.value)} />
        </label>
      </div>
      <button onClick={handleCreateRazz}>Create Razz</button>
    </div>
  );
};

export default RazzCreationForm;
